module.exports = __webpack_public_path__ + "static/media/flash@2x.0ccb051c.png";